import React from 'react';
import {Switch, Route} from 'react-router-dom';

import Applications from './Applications';
import Application from './application/Application';
const ApplicationsContainer = () => {
    return (
        <Switch>
            <Route path='/applications/:uuId' component={Application}/>
            <Route path='/applications' component={Applications}/>
        </Switch>
    )
};


export default ApplicationsContainer;